import axios from 'axios';

import type { Medicine } from '../model';
import type { CollectionApiResponse } from '../model/CollectionApiResponse';

export class MedicineApi {
  static readonly KEY = 'medicine';

  static async getAll(
    search?: string,
    starts_with?: string,
    page?: number,
    size?: number,
  ): Promise<{ total: number; items: Medicine[] }> {
    const { data } = await axios.get<CollectionApiResponse<Medicine>>(
      '/api/v1/medicine',
      {
        params: {
          search,
          starts_with,
          page,
          size,
        },
      },
    );

    return {
      total: data.total,
      items: data.items,
    };
  }
}
